// NOTE: applied as a side effect on import (not via a `setup()` call) so the patch is in place
// before any module that relies on `Promise.allSettled` at evaluation time is pulled into the
// import graph. See the array/flat-map polyfill for the full rationale.
if (typeof Promise !== 'undefined' && typeof Promise.allSettled !== 'function') {
  // eslint-disable-next-line func-names
  Promise.allSettled = function (promises) {
    return Promise.all(
      promises.map(promise =>
        promise.then(value => ({ status: 'fulfilled', value })).catch(reason => ({ status: 'rejected', reason })),
      ),
    );
  };
}
